<template>
    <div class="clr-select" @click="focusAction">
      <div class="clr-select__tags">
        <span class="clr-tag" v-for="(item,index) in resList" :key="'lr_tag_' + index">
          <span class="clr-tag-text" :title="item">{{item}}</span>
          <i class="el-icon-close" @click="deleteAction(index)"></i>
        </span>
        <input :placeholder="placeholder" ref="lrInput" v-model="inputText" type="text" class="clr-input" @blur="blurAction" @keyup.enter="blurAction" @keyup.delete="deleteInputAction"/>
      </div>
      <span class="clr-input__suffix" @click.stop="toggleAction">
        <span class="clr-input__suffix-inner">
          <i class="clr-input-right__icon el-icon-arrow-up" :class="[isShow?'open':'']"></i>
        </span>
      </span>
      <span class="clr-input__suffix close-all" style="right:26px;" @click="closeAll">
        <span class="clr-input__suffix-inner">
          <i class="clr-input-right__icon el-icon-close"></i>
        </span>
      </span>
      <div class="newTabTips" v-show="inputText!=''" @click="blurAction">添加新标签"{{inputText}}"</div>
      <div class="clr-select-dropdown" v-show="isShow" @click="e=>{}">
        <div class="clr-scrollbar">
          <div class="clr-select-dropdown__wrap">
            <ul class="clr-select-dropdown__list">
              <slot></slot>
              <lr-select-input-option v-for="(item, index) in appendList" :label="item" :key="'append_' + index"> </lr-select-input-option>
              <p v-if="!isShowDropDown" class="no-options">暂无可选项</p>
            </ul>
          </div>          
        </div>
      </div>      
    </div>
</template>

<script>
export default {
  name: "lrInput",
  props: {
    value: { type: String, default: null },
    placeholder: { type: String, default: '请选择或者输入' },
  },
  data() {
    return {
      resList:[],
      isShow: false,
      inputText: '',
      allList:[],
      appendList: [],
    };
  },    
  computed: {
    isShowDropDown() {
      let count = 0
      this.allList.forEach(item=>{
        if(this.resList.includes(item)) {
          count ++
        }
      })
      this.appendList.forEach(item=>{
        if(this.resList.includes(item)) {
          count ++
        }
      })
      if(count == this.allList.length + this.appendList.length) {
        return false 
      } else {
        return true
      }

    }
  },
  watch: {
    value(newV,oldV) {
      if(newV != this.resList.join(',')) {
          this.resList = eval('[' + newV + ']' )

      }
    },
    resList(newV,oldV) {
      this.$emit('input', newV.join(','))
    }    
  },
  mounted() {
    if(this.value != this.resList.join(',')) {
         this.resList = this.value.split(',')
      }
  },
  methods: {
    deleteInputAction() {
      if(this.inputText == '' && this.resList.length>0) {
        this.resList.pop()
      }
    },
    optionClickAction(item) {
      this.resList.push(item)
    },
    blurAction() {
      if(this.inputText!='') {
        if(!this.resList.includes(this.inputText)) {
          this.resList.push(this.inputText)
          !this.allList.includes(this.inputText) && this.appendList.push(this.inputText)
          this.inputText = ''
        }
      }
      setTimeout(e=>{
        if(document.activeElement == this.$refs.lrInput) {
          this.isShow = true
        } else {
          this.isShow = false
        }
        
      },200)
    },
    focusAction() {  
        this.isShow = true
        this.$refs.lrInput.focus()
    },
    toggleAction() {
      if(this.isShow) {
        this.isShow = false
        this.$refs.lrInput.blur()
      } else {
        this.focusAction() 
      }
    },
    closeAll() {
      this.resList = []
    },
    deleteAction(index) {
      let arr = []
      this.resList.forEach((item,i)=>{
        if(i != index) {
          arr.push(item)
        }
      })
      this.resList = arr
    },
  },
};
</script>

<style scoped lang="scss">
.clr-select {
    display: inline-block;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding:3px;
    width:100%;
    .clr-select__tags {
      width: 100%;display:flex;flex-wrap:no-wrap;
    }

  .clr-tag {
      background-color: #ecf5ff;
      display: inline-block;
      height: 32px;
      padding: 0 10px;
      line-height: 30px;
      font-size: 12px;
      color: #409eff;
      border: 1px solid #d9ecff;
      max-width:120px;
      white-space: nowrap;
      .clr-tag-text {
        display: inline-block;
        max-width:100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
      
      .el-icon-close {
        border-radius: 50%;
        text-align: center;
        position: relative;
        cursor: pointer;
        font-size: 12px;
        height: 16px;
        width: 16px;
        line-height: 16px;
        vertical-align: middle;
        top: -1px;
        right: -5px;
        background: #ccc;
        color:#fff;
        &:hover {
          background: #bbb;
        }
      }
  }
  .clr-input {
    flex:1;
    min-width:20px;
    margin-left:3px;
    border:0;
    outline:none;
    line-height:30px;
    margin-right:40px;
    font-size:15px;
    &::placeholder {
      color: #ccc;
      font-size:15px;
    }
  }

  .clr-input__suffix {
    position: absolute;
    height: 100%;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all .3s;
    pointer-events: none;
    display: flex;
    align-items: center;
    .clr-input__suffix-inner {
      pointer-events: all;
    }
    .clr-input-right__icon {
        color: #c0c4cc;
        font-size: 14px;
        transition: transform .3s;
        transform: rotate(180deg);
        cursor: pointer;
        &.open {
              transform: rotate(0deg);
        }
    }
  }
  &:hover .clr-input-right__icon  {
    color: #999;
  }
  
}
.close-all:hover .clr-input-right__icon  {
  color: #f00;
}
.newTabTips {
  position: absolute;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  box-sizing: border-box;
  width:100%;
  z-index: 1000;
  height:30px;
  line-height: 30px;
  color: #222;
  position: absolute; top:-31px; left: 0;
  font-size:12px;
  padding:0 12px;
  cursor:pointer;
}
.clr-select-dropdown {
  position: absolute;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  box-sizing: border-box;
  margin: 5px 0;
  width:100%;
  z-index: 1000;
  position: absolute; top:31px; left: 0;
  .clr-scrollbar {
    overflow: hidden;
    position: relative;
  }
  .clr-select-dropdown__wrap {
    max-height: 274px;
    overflow: scroll;
    height: 100%;
    margin-bottom: -17px;
    margin-right: -17px;
  }
  .clr-select-dropdown__list {
    list-style: none;
    padding: 6px 0;
    margin: 0;
    box-sizing: border-box;
  }
  .no-options {
    color:#aaa;font-size:14px;line-height:1.2;padding-left:12px;
  }
}

.clr-select-dropdown__item {
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/LrSelectInput/index.vue